export const storage = typeof localStorage !== 'undefined' ? localStorage : {};

export const getWindow = typeof window !== 'undefined' ? window : {};
